module.exports = __webpack_public_path__ + "static/vimeo_white-fe7256ebca991341f1843c8af0289da5.png";